"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */

/** @internal */

var BackgroundBlurVideoFrameProcessorDelegate = /*#__PURE__*/function () {
  function BackgroundBlurVideoFrameProcessorDelegate() {
    _classCallCheck(this, BackgroundBlurVideoFrameProcessorDelegate);

    this.observers = new Set();
  }
  /**
   * Add an observer to the unique set. If a duplicate observer cannot be added.
   * @param observer An implementation of the observer interface.
   */


  _createClass(BackgroundBlurVideoFrameProcessorDelegate, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.add(observer);
    }
    /**
     * Remove the observer from the set of observers.
     * @param observer An implementation of the observer interface.
     */

  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers.delete(observer);
    }
    /**
     * Call the observer method with the event information. See [[BackgroundBlurVideoFrameProcessorObserver]]
     * for detailed info on this event.
     * @param event
     */

  }, {
    key: "filterFrameDurationHigh",
    value: function filterFrameDurationHigh(event) {
      var _a;

      var _iterator = _createForOfIteratorHelper(this.observers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          (_a = observer.filterFrameDurationHigh) === null || _a === void 0 ? void 0 : _a.call(observer, event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "filterCPUUtilizationHigh",
    value: function filterCPUUtilizationHigh(event) {
      var _a;

      var _iterator2 = _createForOfIteratorHelper(this.observers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var observer = _step2.value;
          (_a = observer.filterCPUUtilizationHigh) === null || _a === void 0 ? void 0 : _a.call(observer, event);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return BackgroundBlurVideoFrameProcessorDelegate;
}();

exports.default = BackgroundBlurVideoFrameProcessorDelegate;